export default __webpack_public_path__ + "assets/MyriadPro-Bold.b6b80de4.svg";